import httpClient from './api/httpClient';

const END_POINT = 'candidato';

export const getOne = () => httpClient.get (END_POINT + '/');
export const getAll = (filtro) => {
    let form = {
        somentePendentes: filtro.somentePendentes,
        somenteNaoRegistrados: filtro.somenteNaoRegistrados,
        campusId: filtro.campus,
        chamadaId: filtro.chamada,
        cursoId: filtro.curso
    }
    return httpClient.post(END_POINT + '/all', form);
}
export const getAllPublico = (filtro) => {
    let form = {
        somentePendentes: filtro.somentePendentes,
        somenteNaoRegistrados: filtro.somenteNaoRegistrados,
        campusId: filtro.campus,
        chamadaId: filtro.chamada,
        cursoId: filtro.curso
    }
    return httpClient.post(END_POINT + '/getAllPublico', form);
}
